var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Your Board Documents")]),_c('a-row',{attrs:{"gutter":24,"type":"flex"}},[_c('a-col',{staticClass:"mb-24",attrs:{"span":24}},[_c('CardDocumentsTable',{attrs:{"columns":_vm.table1Columns}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }